"use client";
import { Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorTextError, ColorGray700, ColorBlue500, SpaceXxs, FontLineHeightMd, FontWeightDefault, ColorTextMedium, ColorRed100, ColorYellow100, ColorWhite, RadiusMd, ColorYellow200, SpaceInsetSm } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (props) => props !== "hasError" && props !== "isIndeterminate" && props !== "isEmphasized"
})`
    padding-right: 8px;
    color: ${(props) => props.hasError ? ColorTextError : ColorGray700};
    &.Mui-checked {
        color: ${(props) => props.hasError ? ColorTextError : ColorBlue500};
    }
    &.Mui-indeterminate {
        color: ${(props) => props.hasError ? ColorTextError : ColorBlue500};
    }
    :hover {
        border-color: ${(props) => props.hasError ? ColorTextError : ColorBlue500};
    }
    &.MuiSvgIcon-root {
        color: ${(props) => props.isIndeterminate && props.hasError ? ColorTextError : null};
    }

    &.MuiButtonBase-root {
        padding: 0px;
    }
    &.Mui-focusVisible {
        outline: 2px solid Highlight;
        outline: 2px solid -webkit-focus-ring-color;
        border-radius: 2px;
    }
`;
const getCheckBoxStyles = ({
  hasError,
  isChecked,
  isEmphasized
}) => ({
  labelCheckbox: {
    paddingRight: "8px",
    color: ColorGray700,
    "&.MuiButtonBase-root": {
      padding: "0px"
    }
  },
  label: {
    padding: isEmphasized || hasError ? SpaceInsetSm : 0,
    border: hasError || isEmphasized ? `2px solid ${hasError ? ColorTextError : ColorYellow200}` : ColorGray700,
    borderRadius: RadiusMd,
    backgroundColor: hasError && !isChecked || isEmphasized ? hasError ? ColorRed100 : ColorYellow100 : ColorWhite,
    display: "flex",
    "&.MuiFormControlLabel-root": {
      display: "flex",
      alignItems: "flex-start",
      margin: 0
    }
  },
  helpertext: {
    color: ColorTextMedium,
    fontWeight: FontWeightDefault,
    marginTop: "0px",
    lineHeight: FontLineHeightMd
  },
  error: {
    color: ColorTextError,
    marginTop: "0px",
    paddingTop: SpaceXxs
  }
});
const StyledLabel = styled(Text)`
    padding-left: 8px;
    margin-top: 3px;
`;
export {
  StyledCheckbox,
  StyledLabel,
  getCheckBoxStyles
};
